<template>
  <div style="height: 100%" class="text-center">
    <span class="account-column">{{ accountCol }}</span>
  </div>
</template>

<script>
export default {
  name: "CompanyAccountHeaderTemplate",
  props: {
    accountCol: {
      type: String,
      default: '-',
    },
  },
};
</script>
